import circleBlue from "../../../assets/circleBlue.png";
import { CreateCirclePolygon } from "./Mappanel.part.ts";
import { Map } from "mapbox-gl";

import { RouteState } from "../../../api/edits/editRoute.responses.ts";
import {
  MapBoxGLMultiPolygon,
  MapBoxGLPoint,
  MapBoxGLPointData,
} from "../../../ts/interfaces/mapbox.interfaces.ts";

// pre:   - route has the route with focused sounds
//        - map has mapbox object on which to display
// post:  - map with displayed focused sounds
export function DisplayFocusedSounds(map: Map, route: RouteState): void {
  let focusedSoundCoords: MapBoxGLPointData = FillDataForFocusedSounds(route);
  map.on("load", () => {
    // add an image to use as a custom marker
    map.loadImage(circleBlue, (error, image) => {
      if (error) throw error;
      map.addImage("circleBlue", image as ImageBitmap);
      // add a GeoJSON point source
      map.addSource("points_focused_sounds_source", {
        type: "geojson",
        // read geometry data from the route object
        data: focusedSoundCoords as any,
      });
      // add a symbol layer
      map.addLayer({
        id: "points_focused_sounds",
        type: "symbol",
        source: "points_focused_sounds_source",
        layout: {
          "icon-image": "circleBlue",
          "icon-size": 0.5,
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "text-allow-overlap": false,
          "text-optional": true,
          "text-field": ["get", "title"],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          "text-size": 14,
          "text-offset": [0.5, -0.5],
          "text-anchor": "bottom-left",
        },
        paint: {
          "text-color": "#202",
          "text-halo-color": "#fff",
          "text-halo-width": 1,
          "text-halo-blur": 1,
        },
      });
    });
  });

  let polygons: number[][][][] = [];
  // create polygon data
  for (let i: number = 0; i < focusedSoundCoords.features.length; ++i) {
    // create range polyline
    let polygonCoords: number[][] = CreateCirclePolygon(
      focusedSoundCoords.features[i].geometry.coordinates,
      route.focusedSounds[i].radius
    );
    polygons.push([polygonCoords]);
  }

  // create mapbox polygon
  map.on("load", () => {
    map.addSource("fs_polygon", {
      type: "geojson",
      data: {
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: polygons,
        },
      } as any,
    });
    // add a new fill layer
    map.addLayer({
      id: "fs_fill",
      type: "fill",
      source: "fs_polygon", // reference the data source
      layout: {},
      paint: {
        "fill-color": "#67a7e6", // blue color fill
        "fill-opacity": 0.3,
      },
    });
    // add an outline layer
    map.addLayer({
      id: "fs_line",
      type: "line",
      source: "fs_polygon",
      layout: {},
      paint: {
        "line-color": "#191c96",
        "line-width": 1,
      },
    });
  });
}

// pre:   route object with focused sounds from which data is created
// post:  returns array data with coordinates of focused sounds
export function FillDataForFocusedSounds(route: RouteState): MapBoxGLPointData {
  let data: MapBoxGLPointData = {
    type: "FeatureCollection",
    features: [],
  };
  // loop through array of points
  for (const fs of route.focusedSounds) {
    let point: MapBoxGLPoint = {
      type: "Feature",
      geometry: {
        type: "Point",
        // add geometry from route object
        coordinates: [fs.longitude, fs.latitude],
      },
      properties: {
        // add name
        title: fs.name,
      },
    };
    data.features.push(point);
  }
  return data;
}

// pre:   - route has the route with focused sounds
//        - map has mapbox object on which to display
// post:  - map layer focused sounds has updated data
export function UpdateFocusedSounds(map: Map, route: RouteState): void {
  if (map != null) {
    // points
    let focusedSoundCoords: MapBoxGLPointData = FillDataForFocusedSounds(route);
    let lay: any = map.getSource("points_focused_sounds_source");
    if (lay !== undefined) {
      lay.setData(focusedSoundCoords);
    }
    // circles
    let polygons: number[][][][] = [];
    // create polygon data
    for (let i: number = 0; i < focusedSoundCoords.features.length; ++i) {
      // create range polyline
      let polygonCoords: number[][] = CreateCirclePolygon(
        focusedSoundCoords.features[i].geometry.coordinates,
        route.focusedSounds[i].radius
      );
      polygons.push([polygonCoords]);
    }
    let layPoly: any = map.getSource("fs_polygon");
    if (layPoly !== undefined) {
      let geojson: MapBoxGLMultiPolygon = {
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: polygons,
        },
      };
      layPoly.setData(geojson);
    }
  }
}
